// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__sHFT8","active":"Statics_active__evh6B"};